import { createHashRouter, createRoutesFromElements, Navigate, Route } from 'react-router';

import AppLayout from '../layout/AppLayout';
import RouteErrorFallback from '../components/RouteErrorFallback';
import { suspendPageLoad } from './suspendPageLoad';
import { routes } from './routes';

// Lazy load pages for better performance and automatically split the bundle accordingly
const Dashboard = suspendPageLoad(() => import('../pages/Status'));
const AccountDetailSidebarLoader = suspendPageLoad(
    () => import('../features/status/accountSidebar/AccountDetailSidebarLoader')
);
const Account = suspendPageLoad(() => import('../pages/./Account'));
const StatusSidebarLoader = suspendPageLoad(() => import('../features/account/statusSidebar/StatusSidebarLoader'));
const Activity = suspendPageLoad(() => import('../pages/Activity'));
const Bookings = suspendPageLoad(() => import('../pages/Bookings'));

const routesFromElements = createRoutesFromElements(
    <Route element={<AppLayout />} errorElement={<RouteErrorFallback />}>
        <Route path={routes.STATUS} element={<Dashboard />}>
            <Route path=':accountId' element={<AccountDetailSidebarLoader />} />
        </Route>
        <Route path={routes.ACCOUNT} element={<Account />}>
            <Route path=':accountId/status' element={<Account />} />
            <Route path=':accountId/status/:deviceId' element={<StatusSidebarLoader />} />
        </Route>
        <Route path={routes.ACTIVITY} element={<Activity />} />
        <Route path={routes.BOOKINGS} element={<Bookings />} />
        <Route path='*' element={<Navigate to={routes.STATUS} />} />
    </Route>
);

export const router = createHashRouter(routesFromElements);
